"use client";
// Imports
import { useState, useEffect } from "react";
import { PrevAndNextButton, ComponentWrapper, Container } from "@/components";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { cva } from "class-variance-authority";
import { Img } from "@/components";

export const slideshowStyles = cva(
  "relative flex items-center justify-center w-full h-full mx-auto overflow-hidden rounded-base",
  {
    variants: {
      height: {
        sm: "h-[200px] lg:h-[300px]",
        md: "h-[300px] lg:h-[500px]",
        lg: "h-[500px] lg:h-[700px]",
      },
      width: {
        sm: "w-[300px] lg:w-[400px]",
        md: "w-[500px] lg:w-[900px]",
        lg: "w-[90%] lg:w-[1200px]",
        full: "w-full",
      },
    },
    defaultVariants: {
      height: "md",
    },
  }
);

// Hero Slideshow
export function Slideshow({ type, slides, width = "full", height = "md" }) {
  // Variables
  const [api, setApi] = useState(null);
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }

    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);

    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);

  // Render
  return (
    <ComponentWrapper type={type}>
      <Container>
        <Carousel
          setApi={setApi}
          className={slideshowStyles({ height, width })}
        >
          <CarouselContent height="h-full w-full" className="h-full mx-0">
            {slides.map((slide, index) => (
              <CarouselItem key={index} className="relative h-full">
                <Img
                  data={slide}
                  sizes="100vw"
                  fill
                  className="object-cover w-full h-full"
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="absolute lg:bottom-8 lg:right-8 right-2 bottom-4">
            <PrevAndNextButton
              prevDisabled={current === 1}
              nextDisabled={current === count}
              prev={() => api?.scrollPrev()}
              next={() => api?.scrollNext()}
            />
          </div>
        </Carousel>
      </Container>
    </ComponentWrapper>
  );
}
